import {client} from '@/utils/gql'
import {NotFoundError, ServerError} from '@/utils/server/errors'

import {
  Case_Counterparty_Bool_Exp,
  Case_Counterparty_Insert_Input,
  Case_Counterparty_Order_By,
  Case_Counterparty_Select_Column,
  Case_Counterparty_Set_Input,
  CaseCounterpartyFragment,
} from '../graphqlSdk'
import {WithRequiredProp} from '../types'

const getByIdOrNull = async (id: string): Promise<CaseCounterpartyFragment | null> =>
  (await client.caseCounterpartyGetById({id})).case_counterparty_by_pk ?? null

const getById = async (id: string): Promise<CaseCounterpartyFragment> => {
  const response = await getByIdOrNull(id)

  if (!response) {
    throw new NotFoundError('Case counterparty getByIdOrNull returned null', {id})
  }

  return response
}

const getMany = async (
  where: Case_Counterparty_Bool_Exp,
  order_by?: Case_Counterparty_Order_By,
  offset?: number,
  limit?: number,
  distinct_on?: Case_Counterparty_Select_Column,
): Promise<CaseCounterpartyFragment[]> =>
  (await client.caseCounterpartyGetMany({where, order_by, offset, limit, distinct_on}))
    .case_counterparty

const insertOne = async (
  object: WithRequiredProp<Case_Counterparty_Insert_Input, 'created_by_user_id'>,
): Promise<CaseCounterpartyFragment> => {
  const response = (
    await client.caseCounterpartyInsertOne({
      object: {
        ...object,
        updated_by_user_id: object.updated_by_user_id ?? object.created_by_user_id,
      },
    })
  ).insert_case_counterparty_one

  if (!response) {
    throw new ServerError('Case counterparty insertOne returned null', {
      object,
    })
  }

  return response
}

const updateOne = async (
  id: string,
  changes: WithRequiredProp<Case_Counterparty_Set_Input, 'updated_by_user_id'>,
): Promise<CaseCounterpartyFragment> => {
  const response = (await client.caseCounterpartyUpdateOne({id, changes}))
    .update_case_counterparty_by_pk

  if (!response) {
    throw new ServerError('Case counterparty updateOne returned null', {id, changes})
  }

  return response
}

export const caseCounterpartyOrm = {
  getByIdOrNull,
  getById,
  getMany,
  insertOne,
  updateOne,
}
